/* import __COLOCATED_TEMPLATE__ from './signup-slug.hbs'; */
import Component from '@ember/component';

/** @type {function} */
const noop = () => { };

/** @module */
const SignupSlug = Component.extend({

  /** @inheritDoc */
  tagName: '',

  /** @type {string} */
  value: '',

  /** @type {string} */
  label: '',

  /** @type {string} */
  path: '',

  /** @type {boolean} */
  disabled: false,

  /** @inheritDoc */
  actions: {

    /**
     *
     */
    handleBlur() {
      this.get('onblur')?.();
    },

    /**
     * @param {string} value
     */
    handleInput(value) {
      this.get('oninput')?.(value);
    },
  },
});

export default SignupSlug;
